
























































































































































































































































































































import { TutorSession } from "@/views/Tutorials.vue";
import { Course, Tutorial } from "@/views/TutorialsAdmin.vue";
import LineChart from "@/components/LineChart.vue";
import { defineComponent, ref, reactive } from "@vue/composition-api";
import { useUserServiceInject } from "@/context";

export interface Profile {
  id: number;
  username: string;
  firstName: string;
  lastName: string;
  ipad: boolean;
  tutorials: Tutorial[];
}

export default defineComponent({
  name: "ProfileView",
  data() {
    return {
      isFormValid: true,
      participantRules: [
        (v: any) => v < 100 || "Ihre Eingabe muss kleiner 100 sein.",
        (v: any) => v >= 0 || "Ihre Eingabe muss größer gleich 0 sein.",
        (v: any) =>
          /^(0|[1-9][0-9]{0,1})$/.test(v) ||
          "Es sind nur Ziffern und keine führenden Nullen erlaubt.",
      ],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "Datum",
          value: "date",
          width: "27%",
        },
        { text: "Status", value: "status", width: "27%" },
        { text: "Teilnehmer", value: "participants", width: "27%" },
        { text: "", value: "controls", sortable: false, width: "15%" },
      ];
    },
    getSessionItems() {
      const tutorials: Tutorial[] = this.selectedTutorial as Tutorial[];
      const sessionsByGroup = this.tutorSessions as {
        [key: string]: TutorSession[];
      };

      const tutorial: Tutorial | undefined = tutorials[0];
      const sessions: TutorSession[] | undefined =
        sessionsByGroup[tutorial.name];

      const dateFunc = this.getExactDate as (
        group: string,
        day: string
      ) => string;
      const statusFunc = this.formatStatus as (s: string | undefined) => string;

      const items = [];
      for (let i = 0; i < sessions.length; i++) {
        const sess = sessions[i];
        items.push({
          date: dateFunc(sess.group, sess.day) as string,
          status: statusFunc(sess.status) as string,
          participants: sess.participants,
          id: sess.id,
          group: sess.group,
          day: sess.day,
        });
      }
      return items;
    },
  },
  methods: {
    getCourseTutorials() {
      const profile: Profile | undefined = this.profiles[0];
      const course = this.selectedCourse;
      if (!profile) return [];
      return profile.tutorials.filter(
        (tutorial: Tutorial) => tutorial.course === course.value
      );
    },
    formatStatus(s: string | undefined): string {
      if (s === "PLANED") {
        return "geplant";
      } else if (s === "MODIFIED") {
        return "modifiziert";
      } else if (s === "CANCELED") {
        return "abgesagt";
      } else {
        return "";
      }
    },
    formatCap(c: string | undefined): string {
      if (c === "NOT_CROWDED") {
        return "kaum";
      } else if (c === "NORMAL") {
        return "normal";
      } else if (c === "CROWDED") {
        return "stärker";
      } else if (c === "BUSY") {
        return "voll";
      } else {
        return "#3D82AF";
      }
    },
    getTableData() {
      const tutorial: Tutorial | undefined = this.selectedTutorial[0];
      if (!tutorial) return [];
      return [
        {
          key: "Raum",
          value: tutorial.room,
          action: {
            method: this.changeRoom,
            text: "Bitte geben Sie den Raum an:",
            type: "text",
          },
        },
        {
          key: "Link",
          value: tutorial.link,
          action: {
            method: this.changeLink,
            text: "Bitte geben Sie den Link an:",
            type: "text",
          },
        },
        {
          key: "Raumzugangscode",
          value: tutorial.password,
          action: {
            method: this.changePassword,
            text: "Bitte geben Sie den Raumzugangscode an:",
            type: "text",
          },
          tooltip: "Der Zugangscode zu dem Link, falls vorhanden.",
        },
        {
          key: "Belegung",
          value: this.formatCap(tutorial.capacity),
          action: {
            method: this.changeCapacity,
            text: "Bitte geben Sie die Belegung an:",
            type: "text",
            values: [
              { text: "kaum", value: "NOT_CROWDED" },
              { text: "normal", value: "NORMAL" },
              { text: "stärker", value: "CROWDED" },
              { text: "voll", value: "BUSY" },
            ],
          },
        },
        {
          key: "Format",
          value: this.formatFormat2(tutorial.format as string),
          action: {
            method: this.changeFormat,
            text: "Bitte geben Sie das Format an:",
            type: "text",
            values: [
              { text: "präsenz", value: "PRESENCE" },
              { text: "online", value: "ONLINE" },
            ],
          },
        },
      ];
    },
    updateParticipants(
      sessionId: number | undefined,
      participants: number | undefined
    ) {
      if (participants && participants >= 0 && participants <= 99) {
        this.$axios
          .patch("tutor_sessions/" + sessionId + "/", {
            participants: participants,
          })
          .then(() => {
            const tutorial: Tutorial | undefined = this.selectedTutorial[0];
            if (!tutorial) return;
            const sessions: TutorSession[] | undefined =
              this.tutorSessions[tutorial.name];
            if (!sessions) return;
            const session: TutorSession | undefined = sessions.find(
              (s: TutorSession) => s.id == sessionId
            );
            if (!session) return;
            session.participants = participants;
            participants = undefined;
          })
          .catch(() => {
            alert(this.$t("tutorSession.saveFailed"));
          });
      }
    },
    customSort(items: any[], index: any, isDesc: any) {
      if (index[0] === "date") {
        items.sort((a, b) => {
          a = a.date.split(".").reverse().join("");
          b = b.date.split(".").reverse().join("");
          if (!isDesc[0]) {
            return a > b ? 1 : a < b ? -1 : 0;
          } else {
            return a > b ? -1 : a < b ? 1 : 0;
          }
        });
      } else if (index[0] === "status") {
        items.sort((a, b) => {
          a = a.status;
          b = b.status;
          if (!isDesc[0]) {
            return a > b ? 1 : a < b ? -1 : 0;
          } else {
            return a > b ? -1 : a < b ? 1 : 0;
          }
        });
      } else {
        items.sort((a, b) => {
          a = a.participants;
          b = b.participants;
          if (!isDesc[0]) {
            return a > b ? 1 : a < b ? -1 : 0;
          } else {
            return a > b ? -1 : a < b ? 1 : 0;
          }
        });
      }
      return items;
    },
  },
  setup(props, { root }) {
    const { username, isStaff } = useUserServiceInject();
    const profiles = ref<Profile[]>([]);
    const courses = ref<Course[]>([]);
    const tutorSessions = ref<{ [key: string]: TutorSession[] }>({});
    const chartOptions = reactive({
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            display: true,
            ticks: {
              beginAtZero: true,
              min: 0,
              suggestedMax: 50,
              stepSize: 5,
            },
          },
        ],
      },
    });
    const selectedCourse = reactive({ value: "" });
    const selectedTutorial = ref<Tutorial[]>([]);

    const paramUsername = root.$route.params.username ?? username.value;
    let editAllowed = false;

    if (isStaff.value || paramUsername == username.value) {
      editAllowed = true;
    }

    root.$axios
      .get("tutors/get_name_username/", {
        params: { tutor: paramUsername },
      })
      .then((res) => {
        const data = res.data;
        const tutorials: Tutorial[] = [];
        if (data["tutorials"] && data["tutorials"].length) {
          for (const tutorialData of data["tutorials"]) {
            const newTutorial: Tutorial = {
              id: tutorialData["id"],
              // eslint-disable-next-line @typescript-eslint/camelcase
              responsible_tutor: tutorialData["responsible_tutor"],
              name: tutorialData["name"],
              day: tutorialData["day"],
              start: tutorialData["start"],
              end: tutorialData["end"],
              capacity: tutorialData["capacity"],
              link: tutorialData["link"],
              room: tutorialData["room"],
              course: tutorialData["course"],
              format: tutorialData["format"],
              password: tutorialData["link_password"],
            };
            tutorials.push(newTutorial);
          }
        }

        const newProfile: Profile = {
          id: data["id"],
          username: data["username"],
          firstName: data["first_name"],
          lastName: data["last_name"],
          ipad: data["ipad"],
          tutorials: tutorials,
        };

        root.$axios
          .get("tutor_sessions/get_tutor_username/", {
            params: { tutor: data["id"] },
          })
          .then((req) => {
            for (const session of req.data) {
              const newSession: TutorSession = {
                id: session["id"],
                group: session["group"],
                name: session["name"],
                day: session["day"],
                start: session["start"],
                end: session["end"],
                status: session["status"],
                participants: session["participants"]
                  ? session["participants"]
                  : 0,
                tutor: session["tutor"],
              };
              if (tutorSessions.value[newSession.name]) {
                tutorSessions.value[newSession.name].push(newSession);
              } else {
                tutorSessions.value[newSession.name] = [newSession];
              }
            }
            profiles.value.push(newProfile);

            root.$axios.get("courses").then((req) => {
              for (const course of req.data) {
                const newCourse: Course = {
                  id: course["id"],
                  startDate: course["start_date"],
                  endDate: course["end_date"],
                  name: course["name"],
                };
                courses.value.push(newCourse);
              }
              if (courses.value.length) {
                selectedCourse.value =
                  courses.value[courses.value.length - 1].id ?? "";
              }
              const tut = profiles.value[0].tutorials.filter(
                (tutorial) => tutorial.course === selectedCourse.value
              );
              if (tut.length) {
                selectedTutorial.value.push(tut[0]);
              }
            });
          });
      })
      .catch();

    const getExactDate = (group: string, day: string): string => {
      let dateString = "";
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      } as const;

      const weekList = ["Mo", "Di", "Mi", "Do", "Fr"];
      const date = new Date(group);
      date.setDate(date.getDate() + weekList.indexOf(day));

      dateString = date.toLocaleDateString("de-DE", options);

      return dateString;
    };

    const getTutorial = (key: string): Tutorial | undefined => {
      return profiles.value[0].tutorials
        .filter((tutorial) => tutorial.course === selectedCourse.value)
        .find((tutorial) => tutorial.name == key);
    };

    const goToTutorSessionView = (id: number, tutorialId: string) => {
      root.$router.push({
        name: "tutorials.id",
        params: {
          sessionId: id.toString(),
          tutorialId: tutorialId,
        },
      });
    };

    const localDateStringToDate = (dateString: string): Date => {
      const dateStringArray = dateString.split(".");
      if (dateStringArray.length) {
        const returnDate = new Date(
          parseInt(dateStringArray[2]),
          parseInt(dateStringArray[1]) - 1,
          parseInt(dateStringArray[0])
        );
        return returnDate;
      }
      return new Date();
    };

    const getChartData = (
      tutorSessions: TutorSession[],
      courseId: string
    ): any[] => {
      let startDateString = "";
      let endDateString = "";

      for (let i = 0; i < courses.value.length; i++) {
        if (courses.value[i].id == courseId) {
          startDateString = courses.value[i].startDate;
          endDateString = courses.value[i].endDate;
        }
      }
      if (!tutorSessions) return [];

      let chartDataArray = tutorSessions
        .filter((session) => session.status !== "CANCELED")
        .map((tutorSession) => {
          const chartData = {
            participants: tutorSession.participants,
            date: getExactDate(tutorSession.group, tutorSession.day),
          };
          return chartData;
        })
        .sort((a, b) => {
          const dateA = a.date.split(".").reverse().join("");
          const dateB = b.date.split(".").reverse().join("");
          return dateA > dateB ? 1 : dateA < dateB ? -1 : 0;
        });
      if (startDateString && endDateString) {
        const startDate = new Date(startDateString);
        startDate.setHours(0);
        const endDate = new Date(endDateString);
        endDate.setHours(23);

        chartDataArray = chartDataArray.filter(
          (data) =>
            localDateStringToDate(data.date) >= startDate &&
            localDateStringToDate(data.date) <= endDate
        );
      }
      return chartDataArray;
    };

    const changeCapacity = (tutorialName: string) => {
      const tutorial = getTutorial(tutorialName);
      if (tutorial) {
        const tutorialId = tutorial.id;
        if (tutorialId) {
          root.$axios
            .put(`tutorials/${tutorialId}/`, {
              capacity: tutorial.capacity,
              // eslint-disable-next-line @typescript-eslint/camelcase
              responsible_tutor: tutorial.responsible_tutor,
            })
            .catch((err) => {
              alert(root.$t("profile.alert.failed"));
            });
        }
      }
    };

    const changeRoom = (tutorialName: string) => {
      const tutorial = getTutorial(tutorialName);
      if (tutorial) {
        const tutorialId = tutorial.id;

        if (tutorialId) {
          root.$axios
            .put(`tutorials/${tutorialId}/`, {
              room: tutorial.room,
              // eslint-disable-next-line @typescript-eslint/camelcase
            })
            .catch(() => {
              alert(root.$t("profile.alert.failed"));
            });
        }
      }
    };

    const changeLink = (tutorialName: string) => {
      const tutorial = getTutorial(tutorialName);
      if (tutorial) {
        const tutorialId = tutorial.id;
        if (tutorialId) {
          root.$axios
            .put(`tutorials/${tutorialId}/`, {
              link: tutorial.link,
              // eslint-disable-next-line @typescript-eslint/camelcase
              responsible_tutor: tutorial.responsible_tutor,
            })
            .catch(() => {
              alert(root.$t("profile.alert.failed"));
            });
        }
      }
    };

    const changeFormat = (tutorialName: string) => {
      const tutorial = getTutorial(tutorialName);
      if (tutorial) {
        const tutorialId = tutorial.id;
        if (tutorialId && tutorial.format) {
          root.$axios
            .put(`tutorials/${tutorialId}/`, {
              format: tutorial.format,
              // eslint-disable-next-line @typescript-eslint/camelcase
              responsible_tutor: tutorial.responsible_tutor,
            })
            .catch(() => {
              alert(root.$t("profile.alert.failed"));
            });
        }
      }
    };

    const changePassword = (tutorialName: string) => {
      const tutorial = getTutorial(tutorialName);
      if (tutorial) {
        const tutorialId = tutorial.id;
        if (tutorialId) {
          root.$axios
            .put(`tutorials/${tutorialId}/`, {
              // eslint-disable-next-line @typescript-eslint/camelcase
              link_password: tutorial.password,
              // eslint-disable-next-line @typescript-eslint/camelcase
              responsible_tutor: tutorial.responsible_tutor,
            })
            .catch(() => {
              alert(root.$t("profile.alert.failed"));
            });
        }
      }
    };

    const getSessionsOfCourse = (
      courseId: string,
      sessions: TutorSession[]
    ): TutorSession[] => {
      let startDateString = "";
      let endDateString = "";

      for (let i = 0; i < courses.value.length; i++) {
        if (courses.value[i].id == courseId) {
          startDateString = courses.value[i].startDate;
          endDateString = courses.value[i].endDate;
        }
      }

      if (startDateString && endDateString && sessions) {
        const newSessionsList = sessions.filter(
          (session) =>
            new Date(session.group) >= new Date(startDateString) &&
            new Date(session.group) <= new Date(endDateString)
        );

        return newSessionsList;
      } else {
        return sessions;
      }
    };

    const getTutorialsOfCourse = (courseId: string, keys: string[]): any[] => {
      const tutorials = profiles.value[0].tutorials
        .filter((tutorial) => tutorial.course === courseId)
        .map((tutorial) => tutorial.name);
      const contained: string[] = [];
      for (let i = 0; i < keys.length; i++) {
        if (tutorials.indexOf(keys[i]) != -1) {
          contained.push(keys[i]);
        }
      }
      return Array.from(new Set(contained));
    };

    const formatFormat2 = (formatStr: string): string => {
      if (formatStr == "ONLINE") {
        return "online";
      } else if (formatStr == "PRESENCE") {
        return "präsenz";
      } else return "";
    };

    return {
      profiles,
      courses,
      tutorSessions,
      chartOptions,
      selectedCourse,
      selectedTutorial,
      editAllowed,

      getTutorialsOfCourse,
      getSessionsOfCourse,
      changePassword,
      changeLink,
      changeRoom,
      changeCapacity,
      goToTutorSessionView,
      getChartData,
      getTutorial,
      getExactDate,
      changeFormat,
      formatFormat2,
    };
  },
  components: { LineChart },
});
